import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

import Select from 'react-select';
import {
  Box,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  Flex,
  VStack,
  HStack,
  IconButton,
  Spinner,
  Center,
} from "@chakra-ui/react"
import { AiOutlineSave } from 'react-icons/ai';
import { useStores } from 'hooks/useStores';

const EditModal = ({ onClose, data }) => {
  const { t } = useTranslation();

  const { rolesStore: { roles }, usersStore: { saveRole, ban, unBan } } = useStores();

  const { id, userName, role, banned } = data || {};

  const options = roles.map(({ name }) => ({
    value: name,
    label: name
  }))

  const [roleOption, setRoleOption] = useState();

  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    setRoleOption(options.find(({ value }) => value === role));
  }, [role])

  const onSaveRole = async () => {
    setIsSaving(true);
    await saveRole(id, roleOption.value);
    setIsSaving(false);
    onClose(true);
  }

  const onBan = async () => {
    setIsSaving(true);
    await ban(id);
    setIsSaving(false);
    onClose(true);
  }

  const onUnBan = async () => {
    setIsSaving(true);
    await unBan(id);
    setIsSaving(false);
    onClose(true);
  }

  return (
    <Modal isOpen={!!data} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        {isSaving && <Center position="absolute"
          top={0}
          bottom={0}
          left={0}
          right={0}
          background="rgba(255,255,255,0.6)"
          zIndex={1}
        >
          <Spinner />
        </Center>}
        <ModalHeader>{t('Edit user')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Heading fontSize="lg">{userName}</Heading>
          <VStack my={4}>
            <Box w="full">
              <Text>{t('Role')}</Text>
              <HStack>
                <Box as={Select} flex={1} options={options} value={roleOption} onChange={setRoleOption} />
                <IconButton icon={<AiOutlineSave />} onClick={onSaveRole} />
              </HStack>
            </Box>
            <Box w="full" pt={8}>
              {banned ? (
                <Button isFullWidth colorScheme="red" onClick={onUnBan}>{t('UN BAN')}</Button>
              ) : (
                <Button isFullWidth colorScheme="red" onClick={onBan}>{t('BAN')}</Button>
              )}
            </Box>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal >
  )
}

export default observer(EditModal);
